import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
  icon?: string;
  required?: boolean;
}

export function Input({
  label,
  hint,
  error,
  icon,
  required,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || `input-${Math.random().toString(36).substring(7)}`;

  return (
    <div className="form-group">
      {label && (
        <label htmlFor={inputId}>
          {label}
          {required && <span style={{ color: 'var(--danger)' }}> *</span>}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        {icon && (
          <i
            className={icon}
            style={{
              position: 'absolute',
              left: '14px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'var(--text-light)',
              fontSize: '16px',
              pointerEvents: 'none',
            }}
          ></i>
        )}
        <input
          id={inputId}
          className={`form-control ${icon ? 'with-icon' : ''} ${error ? 'error' : ''} ${className}`}
          style={icon ? { paddingLeft: '40px' } : undefined}
          {...props}
        />
      </div>
      {hint && !error && <small className="form-help">{hint}</small>}
      {error && <small className="form-error">{error}</small>}
    </div>
  );
}
